import { render } from "./CyberBtn.vue?vue&type=template&id=f966836a&scoped=true"
import script from "./CyberBtn.vue?vue&type=script&lang=js"
export * from "./CyberBtn.vue?vue&type=script&lang=js"

import "./CyberBtn.vue?vue&type=style&index=0&id=f966836a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f966836a"]])

export default __exports__